import { render } from "./ProposalModalHost.vue?vue&type=template&id=33371c1e"
import script from "./ProposalModalHost.vue?vue&type=script&lang=ts"
export * from "./ProposalModalHost.vue?vue&type=script&lang=ts"
script.render = render

export default script